import React from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import ConnectorAuth from './ConnectorAuth'
import { CONNECTORS } from '../connectors'
import { ROUTES } from '../routes'

// Маршрут /integrations/:slug/connect — точка входа в подключение коннектора.
// Делает connect-флоу URL-driven (а не модальным состоянием галереи).
export default function ConnectorConnect ({ user }) {
  const { slug } = useParams()
  const navigate = useNavigate()
  const entry = CONNECTORS[slug]

  if (!entry) {
    return (
      <div style={s.notFound}>
        <div style={s.notFoundTitle}>Коннектор не найден</div>
        <Link to={ROUTES.INTEGRATIONS} style={s.link}>← Интеграции</Link>
      </div>
    )
  }

  const connector = { slug, name: entry.title }
  return (
    <ConnectorAuth
      connector={connector}
      onBack={() => navigate(ROUTES.INTEGRATIONS)}
    />
  )
}

const s = {
  notFound: { textAlign: 'center', padding: 48 },
  notFoundTitle: { fontSize: 18, fontWeight: 600, color: '#0D2137', marginBottom: 16 },
  link: { color: '#0E4D72', fontSize: 14, textDecoration: 'none', fontWeight: 500 }
}
